enum License {
  MBANK = 'MBANK',
  MELEMENTS = 'MELEMENTS',
}

export default License;
